import { render } from "./ObjectIdRefObjCom.vue?vue&type=template&id=33cf14c4&scoped=true"
import script from "./ObjectIdRefObjCom.vue?vue&type=script&lang=js"
export * from "./ObjectIdRefObjCom.vue?vue&type=script&lang=js"

import "./ObjectIdRefObjCom.vue?vue&type=style&index=0&id=33cf14c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cf14c4"]])

export default __exports__